(ns ui.components.hover-card.view
  (:require
   [reagent.core :as r]
   [oops.core :as oops]
   ["@radix-ui/react-hover-card" :as HoverCard]))

(defn adapt
  [component-name]
  (r/adapt-react-class (oops/oget+ HoverCard component-name)))

(def hover-card-primitive (adapt "Root"))
(def hover-card-trigger-primitive (adapt "Trigger"))
(def hover-card-content-primitive (adapt "Content"))
